/** Converte URLs de plataformas abertas em URL de embed para iframe. */
export function parseVideoEmbedUrl(raw: string): string | null {
  const input = raw.trim();
  if (!input) return null;

  let url: URL;
  try {
    url = new URL(input.includes('://') ? input : `https://${input}`);
  } catch {
    return null;
  }

  const host = url.hostname.replace(/^www\./, '').toLowerCase();

  if (host === 'youtu.be') {
    const id = url.pathname.replace(/^\//, '').split('/')[0];
    return id ? `https://www.youtube.com/embed/${id}` : null;
  }

  if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
    if (url.pathname.startsWith('/embed/')) {
      return `https://www.youtube.com${url.pathname}${url.search}`;
    }
    const v = url.searchParams.get('v');
    if (v) return `https://www.youtube.com/embed/${v}`;
    const shorts = url.pathname.match(/^\/shorts\/([^/]+)/);
    if (shorts?.[1]) return `https://www.youtube.com/embed/${shorts[1]}`;
    return null;
  }

  if (host === 'vimeo.com') {
    const id = url.pathname.split('/').filter(Boolean)[0];
    return id && /^\d+$/.test(id) ? `https://player.vimeo.com/video/${id}` : null;
  }

  if (host === 'player.vimeo.com' && url.pathname.startsWith('/video/')) {
    return url.toString();
  }

  if (host === 'loom.com' || host === 'www.loom.com') {
    const match = url.pathname.match(/\/share\/([a-zA-Z0-9]+)/);
    return match?.[1] ? `https://www.loom.com/embed/${match[1]}` : null;
  }

  if (host.includes('loom.com') && url.pathname.startsWith('/embed/')) {
    return url.toString();
  }

  // iframe direto (plataformas abertas / self-hosted)
  if (url.pathname.includes('/embed') || url.searchParams.has('embed')) {
    return url.toString();
  }

  // aceita URL https genérica apenas se parecer embed explícito
  if (input.includes('<iframe')) {
    const src = input.match(/src=["']([^"']+)["']/i)?.[1];
    return src ? parseVideoEmbedUrl(src) : null;
  }

  return null;
}
